import React from "react";
import { Tooltip } from "antd";
import EditIcon from "../icons/editIcon"
import DeleteIcon from "../icons/deleteIcon"
import ViewEyeIcon from "../icons/viewEyeIcon"
import ViewEyeFocusIcon from "../icons/viewEyeFocusIcon"


export default props => {
    function returnStyle() {
        let radius = 0;
        props.borderRadius ? radius = parseInt(props.borderRadius) : radius = 0;
        
        return props.label ? { paddingRight: 6, paddingLeft: 4, borderRadius: radius } : { borderRadius: radius }
    }

    function returnIcon() {
        switch (props.type) {
            case "edit":
                return <EditIcon style={returnStyle()}/>
            case "delete":
                return <DeleteIcon style={returnStyle()}/>
            case "view":
                return <ViewEyeIcon style={returnStyle()}/>
            case "view-focused":
                return <ViewEyeFocusIcon style={returnStyle()}/>
        }
    }

    return (
        <Tooltip placement="bottom" title={props.text}>
            <button className="button-action" onClick={() => props.callback()}
                style={props.label ? { paddingRight: 15 } : {}}>
                {returnIcon()}{props.label}
            </button>
        </Tooltip>
    )
}
